import { Link } from "react-router-dom";
import { CalendarDays, Tag } from "lucide-react";
import type { BlogPost } from "@/data/blogPosts";

type BlogCardProps = { post: BlogPost };

const BlogCard = ({ post }: BlogCardProps) => (
  <article className="premium-card overflow-hidden group">
    {/* @section: blog-card */}
    <Link to={`/blog/${post.slug}`} className="block h-52 overflow-hidden bg-cream">
      <img src={post.cover} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
    </Link>
    <div className="p-6">
      <div className="mb-4 flex flex-wrap items-center gap-3 text-xs font-bold text-muted-foreground">
        <span className="inline-flex items-center gap-1"><CalendarDays size={15} />{post.date}</span>
        <span className="inline-flex items-center gap-1 rounded-full bg-gold/20 px-3 py-1 text-black"><Tag size={14} />{post.category}</span>
      </div>
      <h3 className="text-xl font-black leading-snug text-black group-hover:text-chinese-red"><Link to={`/blog/${post.slug}`}>{post.title}</Link></h3>
      <p className="mt-3 line-clamp-3 text-sm leading-7 text-muted-foreground">{post.excerpt}</p>
      <Link to={`/blog/${post.slug}`} className="mt-5 inline-flex rounded-full bg-pal-green px-5 py-2.5 text-sm font-extrabold text-white hover:bg-dark-green">اقرأ المزيد</Link>
    </div>
  </article>
);

export default BlogCard;
